import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMilk = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 3.80811C9 3.25582 9.44772 2.80811 10 2.80811H14C14.5523 2.80811 15 3.25582 15 3.80811V7.30811C15 8.2894 15.3832 9.08837 15.8944 10.1109C15.9045 10.1309 15.9145 10.1511 15.9247 10.1713C16.4082 11.1378 17 12.3205 17 13.8081V21.8071L16 21.8081H17C17 22.3604 16.5523 22.8081 16 22.8081H8C7.73478 22.8081 7.48043 22.7028 7.29289 22.5152C7.10536 22.3277 7 22.0733 7 21.8081V13.8081C7 12.3205 7.59179 11.1378 8.07534 10.1713C8.08547 10.1511 8.09555 10.1309 8.10557 10.1109C8.61683 9.08837 9 8.28939 9 7.30811V3.80811ZM9 20.8081H15V13.8081C15 12.8268 14.6168 12.0278 14.1056 11.0053C14.0955 10.9853 14.0855 10.9651 14.0753 10.9449C13.7055 10.2057 13.2723 9.33997 13.0891 8.30811H10.9109C10.7277 9.33997 10.2945 10.2057 9.92466 10.9449C9.91453 10.9651 9.90445 10.9853 9.89443 11.0053C9.38317 12.0278 9 12.8268 9 13.8081V20.8081ZM11 6.30811H13V4.80811H11V6.30811Z",
		fill: "currentColor"
	})
});
export default SvgMilk;
